import React, { useEffect } from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
    InstantSearch,
    Configure,
    SearchBox,
    ClearRefinements,
    CurrentRefinements,
} from 'react-instantsearch';
import { history } from 'instantsearch.js/es/lib/routers';
import { Stats } from './components/stats';
import { ProductCards } from './components/product-cards';
import { Pagination, PaginationButtons } from './components/pagination';
import { RefinementList } from './components/filter';
import { addClassToHtmlElement } from './components/helpers';
import {fire} from '../../Libraries/helpers';
import { CustomClearRefinements } from './components/custom-clear-refinements';

const searchClient = algoliasearch(process.env.MIX_ALGOLIA_APP_ID, process.env.MIX_ALGOLIA_SEARCH_API_KEY);

const Products = (props) => {

    const indexName = process.env.MIX_ALGOLIA_INDEX_PRODUCTS;

    let init = false;

    const onStateChange = ({ uiState, setUiState }) => {
        let params = [];

        params = params.concat(uiState[indexName].refinementList?.solution ?? []);
        params = params.concat(uiState[indexName].refinementList?.brand ?? []);
        params = params.concat(uiState[indexName].refinementList?.mobility ?? []);
        params = params.concat(uiState[indexName].refinementList?.type ?? []);
        params = params.concat(uiState[indexName].refinementList?.group ?? []);

        params.forEach(function(key) {
            // console.log(key)
            window.dataLayer.push({
                event: 'CraftEvent',
                eventCategory: 'Search',
                eventAction: 'Filter Applied',
                eventLabel: key,
            })
        });

        setUiState(uiState);
    }

    const routing = {
        router: history({
            createURL({ qsModule, routeState, location }) {
                const queryParameters = {};

                if (routeState.query) {
                    queryParameters.query = encodeURIComponent(routeState.query);
                }
                if (routeState.page !== 1) {
                    queryParameters.page = routeState.page;
                }
                if (routeState.group) {
                    queryParameters.group = routeState.group.map(encodeURIComponent);
                }
                if (routeState.type) {
                    queryParameters.product = routeState.type.map(encodeURIComponent);
                }
                if (routeState.mobility) {
                    queryParameters.type = routeState.mobility.map(encodeURIComponent);
                }
                if (routeState.solution) {
                    queryParameters.solution = routeState.solution.map(encodeURIComponent);
                }
                if (routeState.brand) {
                    queryParameters.brand = routeState.brand.map(encodeURIComponent);
                }

                const queryString = qsModule.stringify(queryParameters, {
                    addQueryPrefix: true,
                    arrayFormat: 'comma',
                    encode: false,
                });

                return `${location.pathname}${queryString}`;
            },

            parseURL({ qsModule, location }) {

                const { query = '', page, group = [], product = [], type = [], solution = [], brand = [] } = qsModule.parse(
                    location.search.slice(1),
                    { comma: true },
                );

                return {
                    query: decodeURIComponent(query),
                    page,
                    group: (Array.isArray(group) ? group : [group]).filter(Boolean).map(decodeURIComponent),
                    type: (Array.isArray(product) ? product : [product]).filter(Boolean).map(decodeURIComponent),
                    mobility: (Array.isArray(type) ? type : [type]).filter(Boolean).map(decodeURIComponent),
                    solution: (Array.isArray(solution) ? solution : [solution]).filter(Boolean).map(decodeURIComponent),
                    brand: (Array.isArray(brand) ? brand : [brand]).filter(Boolean).map(decodeURIComponent),
                };
            },
        }),
        stateMapping: {
            stateToRoute(uiState) {
                const indexUiState = uiState[indexName];

                return {
                    q: indexUiState.query,
                    type: indexUiState.refinementList?.type,
                    group: indexUiState.refinementList?.group,
                    mobility: indexUiState.refinementList?.mobility,
                    solution: indexUiState.refinementList?.solution,
                    brand: indexUiState.refinementList?.brand,
                    page: indexUiState.page,
                };
            },
            routeToState(routeState) {

                if (!init) {
                    setTimeout(window.filtersSidebar, 100);
                    init = true;
                }

                return {
                    [indexName]: {
                        query: routeState.q,
                        refinementList: {
                            type: routeState.type,
                            group: routeState.group,
                            mobility: routeState.mobility,
                            solution: routeState.solution,
                            brand: routeState.brand,
                        },
                        page: routeState.page,
                    },
                };
            },
        },
    };

    const params = new URLSearchParams(document.location.search);

    let facetFilters = ['language:' + props.language];

    if (props.category) {
        facetFilters.push('group:' + props.category);
    }
    if (props.subcategory) {
        facetFilters.push('type:' + props.subcategory);
    }

    let filters = [];

    if (!props.subcategory) {
        const open = !!params.get((props.category ? 'type' : 'group'));

        filters.push({attr: props.category ? 'type' : 'group', title: props.translationsFilterProduct, children: [], open: open});
    }
    if (props.showType) {
        filters.push({attr: 'mobility', title: props.translationsFilterType, children: [], open: !!params.get('mobility')});
    }
    if (props.showSolution) {
        filters.push({attr: 'solution', title: props.translationsFilterSolution, children: [], open: !!params.get('solution')});
    }
    filters.push({attr: 'brand', title: props.translationsFilterBrand, children: [
        {
            key: 'Dantherm',
            items: ['Aerial', 'Biocool', 'Calorex', 'SET', 'Simplify'],
        },
        {
            key: 'Master',
            items: ['Heylo', 'Sovelor'],
        },
        {
            key: 'Trotec',
            items: [],
        },
        {
            key: props.translationsFilterResellers,
            items: [],
        },
    ], open: !!params.get('brand')});

    let filterParams = 'language:' + props.language + ' AND enabled:1';

    if (props.category) {
        filterParams += ' AND group:"' + props.category + '"';
    }

    useEffect(() => {
        setTimeout(() => fire('sticky-sidebars::init'), 100);

        return addClassToHtmlElement('instant-scroll')
    }, []);

    return (
        <InstantSearch searchClient={searchClient} indexName={indexName} routing={routing} onStateChange={onStateChange}>
            <Configure
                hitsPerPage={props.perpage}
                facetFilters={facetFilters}
                filters={filterParams}
            />

            <div className="flex flex-col flex-wrap justify-between gap-6 px-6 my-8 md:my-10 lg:flex-row lg:flex-nowrap lg:my-12 xl:my-14">

                <div className="flex items-center justify-between lg:hidden">
                    <button data-toggle-filters type="button" className="flex items-center border-2 border-grey-300 px-3 py-1 rounded">
                        <span><svg className="w-4 h-auto" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1.265)" stroke="#000" strokeWidth="1.2" fill="none" fillRule="evenodd"><path d="M0 1.421H14.213M0 5.62H14.213M0 9.82H14.213"/><circle fill="#FFF" cx="3.198" cy="1.421" r="1.421"/><circle fill="#FFF" cx="3.198" cy="9.82" r="1.421"/><circle fill="#FFF" cx="10.677" cy="5.621" r="1.421"/></g></svg></span>
                        <span className="pl-2">{props.translationsFiltersearch}</span>
                    </button>

                </div>

                <div data-filters-sidebar className="fixed inset-0 z-[100] w-full hidden lg:block lg:static lg:w-64 lg:z-0 lg:pb-10">
                    <div data-sticky-sidebar className="flex h-full transition-all duration-300 ease-linear lg:h-auto lg:sticky lg:max-h-[calc(100vh-160px)] lg:overflow-scroll lg:pr-4">
                        <div data-toggle-filters data-deadzone className="flex-1 backdrop-blur bg-black/70 lg:hidden"></div>
                        <div className="w-full max-w-xs bg-white p-8 min-h-full overflow-scroll drop-shadow-md lg:overflow-visible lg:p-0 lg:drop-shadow-none">

                            <header className="flex justify-between items-center mb-4 lg:hidden">
                                <button type="button" data-toggle-filters className="flex items-center lg:hidden md:hover:underline cursor-pointer text-grey-700/50">
                                    <svg viewBox="0 0 8 11" width="8" height="11" xmlns="http://www.w3.org/2000/svg" className="fill-current transform rotate-180">
                                        <path fill="currentColor" fillRule="nonzero" d="M.896447 1.517767L2.31066056.10355344l5.20710678 5.20710678L2.31066056 10.517767.896447 9.10355344l3.79210678-3.79289322z" />
                                    </svg>
                                    <span className="pl-2 text-sm">{props.translationsPaginationBack}</span>
                                </button>
                                {/* <h3 className="font-bold">{props.translationsFiltersearch}</h3> */}
                            </header>

                            <div className="flex flex-col gap-6">
                                <div>
                                    <SearchBox
                                        classNames={{
                                            root: 'js-form-label js-ready',
                                            form: 'relative',
                                            input: 'styled-input has-icon',
                                            submit: 'absolute top-0 right-0 p-3 text-green',
                                        }}
                                        submitIconComponent={({ classNames }) => (
                                            <div className={classNames.submitIcon}>
                                                <svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
                                                    <g stroke="currentColor" strokeWidth="2.5" fill="none" fillRule="evenodd">
                                                        <path d="M18.094 4.024a9.473 9.473 0 010 13.394 9.464 9.464 0 01-13.389 0 9.473 9.473 0 010-13.394 9.464 9.464 0 0113.389 0h0zM17.994 17.326l5.722 5.724"></path>
                                                    </g>
                                                </svg>
                                                <span className="sr-only">Search</span>
                                            </div>
                                        )}
                                        resetIconComponent={() => (
                                            <div></div>
                                        )}
                                        placeholder={props.translationsSearch}
                                    />

                                    <CurrentRefinements
                                        classNames={{
                                            'noRefinementRoot': 'hidden',
                                            'list': 'flex items-center flex-wrap gap-3 mt-6',
                                            'item': 'flex items-center flex-wrap gap-3 w-full',
                                            'label': 'hidden',
                                            'category': 'flex items-center gap-2 border border-grey text-grey rounded px-2.5 py-1 text-sm max-w-full',
                                            'categoryLabel': 'truncate',
                                            'delete': 'transition duration-300 ease-linear hover:text-green',
                                        }}
                                    />

                                    <ClearRefinements
                                        excludedAttributes={['language', props.category ? 'group' : '']}
                                        classNames={{
                                            root: 'w-full group mt-3',
                                            button: 'cursor-pointer underline text-grey-400 text-sm leading-none transition duration-300 ease-linear hover:text-green',
                                            disabledButton: 'hidden',
                                        }}
                                        translations={{
                                            resetButtonText: props.translationsFilterClear,
                                        }}
                                    />
                                </div>

                                <div className="flex flex-col gap-6">

                                    <div className="flex flex-col gap-4">
                                        {filters.map(filter => {
                                            return (
                                                <RefinementList
                                                    key={filter.attr}
                                                    attribute={filter.attr}
                                                    subnodes={filter.children}
                                                    category={props.category}
                                                    translation={props.translationsIncorporating}
                                                    types={props.types}
                                                    title={filter.title}
                                                    open={filter.open}
                                                    sortBy={['name']}
                                                    limit={100}
                                                />
                                            )
                                        })}
                                    </div>

                                    <button data-toggle-filters type="button" className="relative border rounded-sm text-center text-sm inline-flex items-center justify-center truncate w-full transition ease-linear duration-300 min-w-[120px] sm:w-auto md:text-[0.9375rem] lg:text-base bg-grey border-grey text-white hover:bg-green hover:border-green h-11 px-4 leading-snug lg:hidden">
                                        <span className="button-text">{ props.translationsFilterApply }</span>
                                    </button>

                                    <CustomClearRefinements
                                        excludedAttributes={['language', props.category ? 'group' : '']}
                                        classNames={{
                                            button: 'cursor-pointer underline text-grey-400 text-sm leading-none transition duration-300 ease-linear hover:text-green',
                                        }}
                                        translations={{
                                            resetButtonText: props.translationsFilterClear,
                                        }}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="relative flex-1 flex flex-col gap-6">

                    {/* <div className="lg:hidden flex items-center justify-between mb-10">
                    <button data-toggle-filters="" type="button" className="flex items-center border-2 border-grey-200 px-3 py-1 rounded">
                        <span><svg className="w-4 h-auto" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1.265)" stroke="#000" strokeWidth="1.2" fill="none" fillRule="evenodd"><path d="M0 1.421H14.213M0 5.62H14.213M0 9.82H14.213"></path><circle fill="#FFF" cx="3.198" cy="1.421" r="1.421"></circle><circle fill="#FFF" cx="3.198" cy="9.82" r="1.421"></circle><circle fill="#FFF" cx="10.677" cy="5.621" r="1.421"></circle></g></svg></span>
                        <span className="pl-2">{props.translationsFiltersearch}</span>
                    </button>
                </div>

                <div data-mount="FilterSidebar">
                    <div className="h-0 flex items-center w-full">
                        <div className="react-loader-container opacity-0 mt-0">
                            <div className="react-loader"></div>
                        </div>
                    </div>
                </div>

                <div className="hidden md:block -mt-1">
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                        <div>
                            <Stats
                                text={props.translationsStats}
                            />
                        </div>
                        <div className="pl-8">
                            <Pagination
                                showFirst={false}
                                showLast={false}
                                padding={2}
                                classNames={{
                                    root: 'pl-8',
                                    list: 'relative z-0 inline-flex text-lg',
                                    link: 'px-4 py-2',
                                    item: 'relative inline-flex items-center bg-white leading-5 font-normal text-grey-700 md:hover:text-green',
                                    selectedItem: '!text-white !bg-grey-700 !rounded-sm',
                                }}
                            />
                        </div>
                    </div>
                </div> */}

                    <ProductCards
                        baseUrl={props.baseurl}
                        noresultsHeading={props.noresultsHeading}
                        noresultsText={props.noresultsText}
                        clamping={props.clamping == '1'}
                        excerpt={props.excerpt == '1'}
                    />

                    <div className="mt-6">

                        <div className="flex-1 flex flex-wrap justify-between sm:hidden">

                            <div className="w-full mb-8 text-center">
                                <Stats
                                    text={props.translationsStats}
                                />
                            </div>

                            <PaginationButtons
                                next={props.translationsPaginationNext}
                                previous={props.translationsPaginationPrevious}
                            />
                        </div>

                        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                            <div>
                                <Stats
                                    text={props.translationsStats}
                                />
                            </div>
                            <div className="pl-8">
                                <Pagination
                                    showFirst={false}
                                    showLast={false}
                                    padding={2}
                                    classNames={{
                                        root: 'pl-8',
                                        list: 'relative z-0 inline-flex text-lg',
                                        link: 'px-4 py-2',
                                        item: 'relative inline-flex items-center px-4 py-2 bg-white leading-5 font-normal text-grey transition ease-linear duration-300 hover:text-green',
                                        selectedItem: '!text-white !bg-grey !rounded-sm',
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </InstantSearch>
    );
}

export default Products
